import styled from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div`
  .title {
    ${tw`text-primary`}
    font-size: 18px;
    font-weight: 700;
    line-height: 23.08px;
    margin-bottom: 20px;
  }

  .filter-btn {
    min-width: 30px;
    min-height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &.active {
      border: 1px solid #e8b12c;
      box-sizing: border-box;
      background: transparent;

      svg > path {
        stroke: #e8b12c;
      }
    }
  }

  @media only screen and (max-width: 639px) {
    .title {
      font-size: 16px;
      margin-bottom: 14px;
    }
  }
`;
export const Searchbar = styled.input.attrs({
  className: 'bg-white focus:outline-none text-black w-full',
})`
  box-shadow: 0px 15px 34px rgba(98, 120, 140, 0.1);
  padding: 15px;
  border-radius: 5px;

  &::placeholder {
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(98, 120 140, 0.3);
  }
`;
export const MenuContainer = styled.div.attrs({
  className: 'bg-white rounded absolute',
})`
  z-index: 111;
  right: 0;
  top: 60px;
  min-width: 212px;
  box-shadow: 0px 15px 34px rgba(98, 120, 140, 0.1);
  padding: 15px;
`;
